import {requiredNonEmptyString} from '../../../utils/validate-payload';

export const facetIdDefinition = requiredNonEmptyString;
